import {defineStore} from 'pinia'

const name = 'menu'

export const useMenuStore = defineStore(name,{

  id: name,

  state: () => ({
        menus: [],
    }
  ),

  actions: {
    load(payload) {
      this.menus = payload;
    },

  },

})
